import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import FilterPanel from '../../../moreCore/UI/FilterPanel/FilterPanel';
// template-instantiated child widgets (data-dojo-type) — bare side-effect imports.
import "../../../moreCore/UI/SelectBox/SelectBox";
import "./TaskApprovalTable";
import "./TaskExecutionApprovalTable";
import TaskApprovalForm from './TaskApprovalForm';
import template from './TaskApprovalHome.html?raw';
// NOTE (JS2TS): original define() also listed dead dojo/dijit deps (connect, array, Color, keys, dijit
// _WidgetBase/_TemplatedMixin/_WidgetsInTemplateMixin, registry, dom-style, dom-construct, mouse) — dropped.

class TaskApprovalHome extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    filterpanels: any = [];
    _isFilterResultLoaded = false;
    _currentFilterSettingsApplied: any = false;
    _currentFilterSettings: any = null;
    _timeout: any = null;


    _maxResultCount = 200;
    _currentStartIndex = 0;

    loadFilterOptions(): void {
        this.StandbyStart();


        this.RequestManager.callfunction(
            "Webtool_API_TaskApproval__GetFilterOptionsJSON",
            null,
            lang.hitch(this, this._onLoadFilterOptionsResponse),
            lang.hitch(this, this._onLoadFilterOptionsError)
        );
    }

    _onLoadFilterOptionsResponse(response: any): void {
        this.StandbyStop();

        console.log("_onLoadFilterOptionsResponse", response);

        var filteropt = response.filterPanelRoot;

        this.prepareFilteroptions(filteropt);

        domClass.remove(this.filterSection, "w3-hide");
    }

    _onLoadFilterOptionsError(error: any): void {

        this.StandbyStop();

        this.showErrorDetailsDlg(error.Message, null, null, "ok", null);

        //alert("Filteroptionen können nicht geladen werden: " + error.Message);
    }

    prepareFilteroptions(data: any): void {
        if (this.filterPanelContainer) {
            (this.UiModder as any).domConstruct.empty(this.filterPanelContainer);
        }
        else {
            alert("this.filterPanelContainer not defined");
            return;
        }
        (this.UiModder as any).domConstruct.empty(this.filterPanelContainer);
        var fp = new FilterPanel();
        this.filterpanel = fp;
        fp.placeAt(this.filterPanelContainer);
        (fp as any).outputFormat = (window as any).FilterPanelFormat ? (window as any).FilterPanelFormat.compact : "compact"; // JS2TS: original used bare enum FilterPanelFormat.compact; das Format lassen wir jetzt mal fix. data.format == "compact" ? "compact" : "default";
        for (var i = 0; i < data.sections.length; i++) {
            var sectionData = data.sections[i];
            fp.addSection(sectionData);
        }
        on(this.filterpanel, "serializedData", lang.hitch(this, this.checkDirtyState_delayed));
        this.filterpanel.serializeData();
        // falls man noch was ergänzen möchte (readonly z.B.)
        //this.filterOptions_additionalConfig();

        setTimeout(lang.hitch(this, this._onClick_Submit), 200);

        this.inputApprovalMonth.addEntry("null", "- keine Einschränkung -", true);// = function (value, label, isSelectable)()

        let date = new Date();
        let maxDate = new Date();
        //maxDate.setMonth(maxDate.getMonth() - 1);
        date.setFullYear(maxDate.getFullYear() - 1);
        date.setDate(1);
        var strValue: any;
        while (date.valueOf() < maxDate.valueOf()) {
            strValue = this.dateToLocalISOString(date);
            let strLabel = this.dateToString(date, "MMMM yyyy");

            this.inputApprovalMonth.addEntry(strValue, strLabel, true);

            date.setMonth(date.getMonth() + 1);
        }

        this.inputApprovalMonth.constructOptions();
        this.inputApprovalMonth.setValue(strValue);
    }


    showErrorDetailsDlg(message: any, header?: any, subtitle?: any, buttons?: any, callback?: any): void {
        let dlg = new GenericDialog();

        if (!header) {
            header = this.translations["TaskApproval_Filter"];
        }

        dlg.show(message, header, subtitle, null, buttons, callback);
    }

    checkDirtyState_delayed(result?: any): void {

        // bestehendes Event unterbrechen
        if (this._timeout != null) {
            clearTimeout(this._timeout);
            this._timeout = null;
        }

        this._timeout = setTimeout(lang.hitch(this, this.checkDirtyState, result), 100);
    }

    checkDirtyState(bForceFalse?: any): void {
        if (bForceFalse === false) {
            this.isDirty = false;
            return;
        }

        var json = this.filterpanel.getData();//{ sections: this.filterpanel.getData() };
        var bValid = json !== null;

        if (json) {
            this._currentFilterSettings = { sections: json };

            this._currentFilterSettings.viewMode = this.viewMode;
            this._currentFilterSettings.dataMode = this.dataMode;
        }


        if (this._currentFilterSettingsApplied != JSON.stringify(this._currentFilterSettings) && bValid === true) {
            this.isDirty = true;
            this.setSubmitButtonStyle();
            this.disableNode(this.tableSection);
        } else {
            this.isDirty = false;
            this.setSubmitButtonStyle();
            this.disableNode(this.tableSection, false);
        }
    }


    _setDirtyAttr(value: any): void {


        this.isDirty = value === true;

        //console.debug("setDirty", this.isDirty);

        this.setSubmitButtonStyle();
    }

    setSubmitButtonStyle(): void {

        //console.debug("setSubmitButtonStyle", this.isDirty);

        domClass.remove(this.btnSubmit, "w3-disabled accentBG mds-hover-bright");
        domClass.remove(this.btnReload, "w3-disabled secondaryBG mds-hover-bright");

        let classesEnabled = "mds-hover-bright accentBG";
        let classesEnabledReload = "mds-hover-bright secondaryBG";
        let classesDisabled = "w3-disabled";
        if ((this.isDirty == true) && this._isRequestActive != true) {
            domClass.add(this.btnSubmit, classesEnabled);
            domClass.remove(this.btnSubmit, classesDisabled);
        } else {
            domClass.add(this.btnSubmit, classesDisabled);
            domClass.remove(this.btnSubmit, classesEnabled);
        }

        domClass.toggle(this.btnReload, classesEnabledReload, !this.isDirty && !this._isRequestActive);
        domClass.toggle(this.btnReload, classesDisabled, this.isDirty || this._isRequestActive);
    }

    _onClick_Reload(evt: any): void {
        if (this._isRequestActive === true || (this.isDirty == true)) {
            return;
        }

        this.getFilterData();
    }

    _onClick_Submit(evt?: any): void {
        if (this._isRequestActive === true || (this.isDirty != true)) {
            return;
        }


        domClass.add(this.filterSection, "w3-disabled");

        this._isFilterResultLoaded = false;

        this.getFilterData();
    }

    getFilterData(): void {
        //if (this.table) {
        //    this.StandbyStart(this.table);
        //}
        var url = window.appRoot + "TaskApproval/GetFilterList";
        this._isRequestActive = true;
        this.setSubmitButtonStyle();
        let data = null;

        data = this._currentFilterSettings;

        //console.debug("getFilterData request", data);
        this._handleEmployeeSubstitution();

        //data.limit = this._maxResultCount;
        //data.currentStartIndex = this._currentStartIndex;

        var stringData = JSON.stringify(data);

        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_TaskApproval__GetFilterlistJSON",
            data,
            lang.hitch(this, this._onGetFilterDataResponse),
            lang.hitch(this, this._onGetFilterDataError)
        );
    }

    _handleEmployeeSubstitution(): void {
        (window as any).taskApprovalSubstitution = null;
        this.hideNode(this.sectionSubstitution, true);
        if (this.filterpanel) {
            let substitution = this.filterpanel.getFilterOptionByName("employee", "substitution");

            //console.debug("Substitution?", substitution);

            if (substitution.selected === true && substitution.data?.value != "me") {
                let label = "";
                for (let entry of substitution.data.valueList) {
                    if (entry.value == substitution.data.value) {
                        label = entry.label;
                        break;
                    }
                }
                (window as any).taskApprovalSubstitution = {
                    ID: substitution.data.value,
                    label: label
                };
            } else {

            }
        }

        if ((window as any).taskApprovalSubstitution) {
            this.hideNode(this.sectionSubstitution, false);
            domAttr.set(this.sectionSubstitution, "innerHTML", this.translations["TaskApproval__SubstitutionActiveMessage"].format((window as any).taskApprovalSubstitution.label));
        }

        domClass.toggle(this.domNode, "w3-pale-yellow", !!(window as any).taskApprovalSubstitution);
    }

    _onGetFilterDataResponse(response: any): void {
        this.StandbyStop();
        domClass.remove(this.filterSection, "w3-disabled");
        this._isRequestActive = false;
        this._currentFilterSettingsApplied = JSON.stringify(this._currentFilterSettings);

        this.checkDirtyState();

        this.hideNode(this.overflowResultsWarning, response.overflowResults !== true)

        //console.debug("_onGetFilterDataResponse", response);

        if (this.dataMode == "tasks") {
            this.table.setData(response.taskList, response.tableLayout);
        } else if (this.dataMode == "executions") {
            this.execTable.setData(response.executionList, response.tableLayout);
        }
        this._handleSelectionArea([]);

        this.hideNode(this.actionBar, response.taskList?.length < 1);
        domClass.remove(this.tableSection, "w3-hide");
    }

    _onGetFilterDataError(error: any): void {
        this.StandbyStop();

        this.showErrorDetailsDlg(error.Message, "Error", null, "ok", null);
        domClass.remove(this.filterSection, "w3-disabled");
        this._isRequestActive = false;

        this.checkDirtyState();
    }


    _onClick_TableRow(entity: any, evt: any): void {
        let highlightExecID = null;
        if (entity && entity.Classname == "Task_executor") {
            highlightExecID = entity.ID;
            entity = entity.ref_Task;
        }

        if (entity) {
            let dlg = new GenericDialog();

            let form = new TaskApprovalForm();

            dlg.show("", entity.Number + " - " + entity.ref_managed_object.tmp_label, null, null, "close", lang.hitch(this, this._onFormDlgResult));

            dlg.addNodeToContent(form.domNode);

            form.loadEntity(entity.ID);

            form.on("approvalSaved", lang.hitch(this, this.getFilterData));

            if (highlightExecID) {
                form.highlight(highlightExecID);
            }
        }
    }

    _onSelectTask(selectedIDs: any): void {
        //console.debug(this.id + " _onSelectTask", selectedIDs);
        this._handleSelectionArea(selectedIDs);
    }

    _selectedIDs: any = [];
    _handleSelectionArea(selectedIDs: any): void {
        this.hideNode(this.sectionSelection_Tasks, this.dataMode != "tasks");
        this.hideNode(this.sectionSelection_Executions, this.dataMode != "executions");

        this.hideNode(this.sectionSelection, selectedIDs?.length < 1);

        this._selectedIDs = selectedIDs;

        this.txtSelectionCount.innerHTML = this._selectedIDs.length.toString();
    }

    _onClick_ApproveSelected(evt: any): void {
        if (!this._selectedIDs?.length) return;

        if (this._selectedIDs.length) {

            let dlg = new GenericDialog();

            let messageHead = this.translations["TaskApproval__ApproveBulkConfirmationHeading"];
            let message = "";
            if (this.dataMode == "tasks") {
                message = this.translations["TaskApproval__ApproveBulkTasksConfirmationMessage"]

            } else if (this.dataMode == "executions") {
                message = this.translations["TaskApproval__ApproveBulkTaskExecutionsConfirmationMessage"]
            }

            dlg.show(
                message.format(this._selectedIDs.length),
                messageHead,
                null,
                null, //"fas fa-times",
                "yesno",
                lang.hitch(this, this._onConfirmApproveBulkDlg));
            //this._saveApprovals(this.currentSelectedItems);
        }
    }

    _onConfirmApproveBulkDlg(result: any): void {

        if (result >= 1) {
            this._approveSelectedTasks();
        }
    }

    _approveSelectedTasks(): void {
        let selection = this._selectedIDs;

        if (!selection?.length) return;

        this.StandbyStart();

        let url = window.appRoot + "TaskApproval/SaveApproval";
        this._isRequestActive = true;

        let data: any = {};

        if (this.dataMode == "tasks") {
            data.taskIDs = selection;
            data.multipleTasks = true;
        } else if (this.dataMode == "executions") {
            data.executionsIDs = selection;
            data.multipleExecutions = true;
        }

        if ((window as any).taskApprovalSubstitution) {
            data.substitutionEmployee = (window as any).taskApprovalSubstitution.ID;
        }

        let selectedMonth = this.inputApprovalMonth.getValue();
        data.selectedMonth = selectedMonth;

        data.approve = true;

        let stringData = JSON.stringify(data);

        this.StandbyStart();

        this.RequestManager.callfunction(
            "Webtool_API_TaskApproval__SaveExecutionApproval",
            data,
            lang.hitch(this, this._onSaveApprovalResponse),
            lang.hitch(this, this._onSaveApprovalError)
        );
    }

    _onSaveApprovalResponse(response: any): void {

        if (typeof (response.approvalCount) == "number") {
            let dlg = new GenericDialog();
            dlg.closeOnEscape = true;
            dlg.show(this.translations["TaskApproval__ApproveBulkTasks_ResultMessage"].format(response.approvalCount, response.taskCount),
                this.translations["TaskApproval__ApproveBulkTasks_ResultHeading"],
                null,
                null,
                "ok");
        }

        this.getFilterData();
    }

    _onSaveApprovalError(error: any): void {
        this.StandbyStop();

        this.showErrorDetailsDlg(error.Message, this.translations["TaskApproval__ApproveBulkTasks_ErrorHeading"], null, "ok", null);
    }

    _onClick_Deselect(evt: any): void {
        this._handleSelectionArea([]);
        this.table.deselect();
        this.execTable.deselect();
    }

    _onClick_SelectAll(evt: any): void {

        if (this.dataMode == "tasks") {
            this.table.selectAll();
            this.execTable.deselect();
        }

        else if (this.dataMode == "executions")
            this.table.deselect();
        this.execTable.selectAll();
    }

    _onFormDlgResult(result: any): void {

    }

    _onClick_Mode(evt: any): void {
        let mode = evt.target.dataset.mode;
        console.log("_onClick_Mode", evt, mode);

        if (mode == this.viewMode || mode == this.dataMode) return;

        if (mode == "executions" || mode == "tasks") {
            this.dataMode = mode;
        } else {
            this.viewMode = mode;
        }

        this._setViewModeButtonStyles();
        this.checkDirtyState_delayed();
    }

    viewMode = 'open';
    dataMode = "executions"; // executions / tasks


    _setViewModeButtonStyles(): void {
        let mode = this.viewMode ? this.viewMode : "open";
        let dataMode = this.dataMode;

        this.hideNode(this.table.domNode, dataMode != "tasks");
        this.hideNode(this.execTable.domNode, dataMode != "executions");

        domClass.toggle(this.btnModeOpen, "mds-hover-bright brightTransparentBG", mode != "open");
        domClass.toggle(this.btnModeReviewed, "mds-hover-bright brightTransparentBG", mode != "reviewed");
        domClass.toggle(this.btnModeTasks, "mds-hover-bright brightTransparentBG", dataMode != "tasks");
        domClass.toggle(this.btnModeExecutions, "mds-hover-bright brightTransparentBG", dataMode != "executions");

        domClass.toggle(this.btnModeOpen, "accentBG noInteraction", mode == "open");
        domClass.toggle(this.btnModeReviewed, "accentBG noInteraction", mode == "reviewed");
        domClass.toggle(this.btnModeTasks, "complimentaryBG noInteraction", dataMode == "tasks");
        domClass.toggle(this.btnModeExecutions, "complimentaryBG noInteraction", dataMode == "executions");
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse

    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        var title = this.translations["TaskApproval__Title"];
        if (title == "" || title == null || typeof (title) == "undefined") {
            title = "ekus Webtool";
        }
        document.title = title;

        this._setViewModeButtonStyles();

        this.loadFilterOptions();

    }
    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }


}
TaskApprovalHome.prototype.declaredClass = 'WidgetCollection.JDM.LabourReview.TaskApprovalHome';

export default mdsWidget(TaskApprovalHome);
